<p-dialog
  #deleteDialog
  modal="true"
  [(visible)]="showModal"
  [closable]="false"
  styleClass="atlas-dialog-m"
  [focusOnShow]="false"
  [contentStyle]="{ 'max-height': '75vh' }"
>
  <ng-template pTemplate="header" show-close="true">
    <h4 class="modal-title text-center">
      {{ 'events.registration.management.delete-registration-confirmation-title' | translate | titlecase }}
    </h4>
  </ng-template>

  <p class="text-center">
    {{ 'events.registration.management.delete-registration-confirm-text' | translate | titlecase }}
    <br />
    <br />
    <input type="checkbox" [(ngModel)]="selectedYes" (ngModelChange)="yesChanged($event)" />{{ 'common.yes' | translate | titlecase }}
    &nbsp;
    <input type="checkbox" [(ngModel)]="selectedNo" (ngModelChange)="noChanged($event)" />{{ 'common.no' | translate | titlecase }}
    <br />
    <br />
  </p>

  <wl-event-v4-registration-wizard-modification-options
    #modificationOptionsComponent
    [hidden]="!hasInvoice"
    [hasPaymentAmount]="hasPaymentAmount"
    [hasRefundableCcPayment]="hasRefundableCcPayment"
    [lineItemAccountingPackageIds]="lineItemAccountingPackageIds"
    [paymentAccountingPackageIds]="paymentAccountingPackageIds"
  ></wl-event-v4-registration-wizard-modification-options>
  <ng-template pTemplate="footer">
    <div class="w-100">
      <div class="flex row-collapse items-center-center w-100 gap-10px">
        <button pButton type="button" class="atlas-btn atlas-btn-primary" [disabled]="!selectedYes || !isValid" (click)="dialogYes()">
          {{ 'events.registration.management.delete-registration-yes-text' | translate | titlecase }}
        </button>
        <button pButton type="button" class="atlas-btn atlas-btn-default" (click)="dialogNo()">
          {{ 'events.registration.management.delete-registration-no-text' | translate | titlecase }}
        </button>
      </div>
    </div>
  </ng-template>
</p-dialog>
